import { apiClient } from './client';
import type { ApiSuccess, PaginationMeta } from '../types';

export interface DealerApplication {
  id: number; applicationCode: string; status: string; registrationSource: string;
  companyName: string; dealerType: string; brandName: string | null; establishmentYear: number | null; website: string | null;
  billingAddress: string | null; shippingAddress: string | null; city: string | null; stateId: number | null; district: string | null; pincode: string | null;
  primaryContactPerson: string | null; designation: string | null; mobile: string | null; alternateMobile: string | null; email: string | null;
  financeContactPerson: string | null; financeEmail: string | null; financeMobile: string | null; paymentTerms: string; creditDays: number | null;
  gstNumber: string | null; panNumber: string | null;
  clientId: number | null; regionId: number | null; salesManagerUserId: number | null;
  loginEmail: string | null; dealerId: number | null;
  verifiedAt: string | null; approvedAt: string | null; rejectionReason: string | null; createdAt: string;
  documents?: { id: number; docType: string; fileName: string; fileUrl: string }[];
}
interface Paginated<T> { data: T[]; meta: PaginationMeta }

export const dealerApplicationsApi = {
  async list(params?: Record<string, unknown>): Promise<Paginated<DealerApplication>> {
    const { data } = await apiClient.get<ApiSuccess<DealerApplication[]>>('/dealer-applications', { params });
    return { data: data.data, meta: data.meta as PaginationMeta };
  },
  async get(id: number) { return (await apiClient.get<ApiSuccess<DealerApplication>>(`/dealer-applications/${id}`)).data.data; },
  async create(body: Record<string, unknown>) { return (await apiClient.post<ApiSuccess<DealerApplication>>('/dealer-applications', body)).data.data; },
  async verify(id: number) { return (await apiClient.post<ApiSuccess<DealerApplication>>(`/dealer-applications/${id}/verify`, {})).data.data; },
  async approve(id: number) { return (await apiClient.post<ApiSuccess<DealerApplication>>(`/dealer-applications/${id}/approve`, {})).data.data; },
  async reject(id: number, reason: string) { return (await apiClient.post<ApiSuccess<DealerApplication>>(`/dealer-applications/${id}/reject`, { reason })).data.data; },
  /** Public self-registration (no auth required). */
  async publicSubmit(body: Record<string, unknown>) {
    return (await apiClient.post<ApiSuccess<{ applicationCode: string; status: string; message: string }>>('/public/dealer-applications', body)).data.data;
  },
};
